var map = {
	"./accenture.png": 9670,
	"./amazon.png": 2856,
	"./capgimini.png": 8242,
	"./cognizant.png": 5464,
	"./fivetran.png": 8789,
	"./hackerearth.white.png": 1279,
	"./infosys.png": 6606,
	"./lti.png": 2066,
	"./mellon.white.png": 4981,
	"./principal.png": 6197,
	"./publicsapient.white.png": 5461,
	"./sahaj.png": 8713,
	"./tcs.png": 6650,
	"./vmware.white.png": 1069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2624;